function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sparkle1-item-1 {\n        fill: url(#sparkle1_gradient);\n      }\n\n      .sparkle1-item-2 {\n        fill: url(#sparkle1_gradient-2);\n      }\n\n      .sparkle1-item-3 {\n        fill: url(#sparkle1_gradient-3);\n      }\n\n      .sparkle1-item-4 {\n        fill: url(#sparkle1_gradient-4);\n      }\n\n      .sparkle1-item-5 {\n        fill: url(#sparkle1_gradient-5);\n      }\n\n      .sparkle1-item-6 {\n        fill: url(#sparkle1_gradient-6);\n      }\n\n      .sparkle1-item-7 {\n        fill: url(#sparkle1_gradient-7);\n      }\n\n      .sparkle1-item-8 {\n        fill: url(#sparkle1_gradient-8);\n      }\n\n      .sparkle1-item-9 {\n        fill: url(#sparkle1_gradient-9);\n      }\n\n      .sparkle1-item-10 {\n        fill: url(#sparkle1_gradient-10);\n      }\n\n      .sparkle1-item-11 {\n        fill: url(#sparkle1_gradient-11);\n      }\n\n      .sparkle1-item-12 {\n        fill: url(#sparkle1_gradient-12);\n      }\n\n      .sparkle1-item-13 {\n        fill: url(#sparkle1_gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient",
  "data-name": "primary gradient",
  x1: 108.51,
  y1: 87.15,
  x2: 108.51,
  y2: 5.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#20c4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#23bff2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#2cb0ee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#3a97e6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#4f74dc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#6947ce"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#8812be"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8f06ba"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-2",
  x1: 106.93,
  y1: 87.15,
  x2: 106.93,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-3",
  x1: 99.17,
  y1: 87.15,
  x2: 99.17,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-4",
  x1: 102.04,
  y1: 87.15,
  x2: 102.04,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-5",
  x1: 84.53,
  y1: 87.15,
  x2: 84.53,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-6",
  x1: 68.44,
  y1: 87.15,
  x2: 68.44,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-7",
  x1: 61.75,
  y1: 87.15,
  x2: 61.75,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-8",
  x1: 43.89,
  y1: 87.15,
  x2: 43.89,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-9",
  x1: 24.36,
  y1: 87.15,
  x2: 24.36,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-10",
  x1: 8.61,
  y1: 87.15,
  x2: 8.61,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-11",
  x1: 3.71,
  y1: 87.15,
  x2: 3.71,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-12",
  x1: 13.66,
  y1: 87.15,
  x2: 13.66,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle1_gradient-13",
  x1: 9.76,
  y1: 87.15,
  x2: 9.76,
  y2: 5.47,
  xlinkHref: "#sparkle1_gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "sparkle 1");

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "_8",
  "data-name": 8,
  className: "sparkle1-item-1 animate-me",
  d: "M89.94,92.23a1.62,1.62,0,0,1-1.6-1.86A3.44,3.44,0,0,1,88.86,89c4.2-7.14,7.93-14.53,11.85-21.82,3.7-6.9,7.43-13.79,11.13-20.69,1.12-2.1,2.18-4.24,3.24-6.37A167.42,167.42,0,0,1,123.77,25c1.12-1.78,2.2-3.58,3.31-5.36a2.89,2.89,0,0,1,.88-1,.46.46,0,0,1,.65,0c.18.18.06.35,0,.54-1.17,2.62-2.41,5.2-3.49,7.85-2.59,6.36-5.41,12.62-8.59,18.71-3.64,7-7.44,13.88-11.19,20.8-2.06,3.79-4.08,7.61-6.12,11.42-2.23,4.17-4.45,8.33-7,12.29a6.73,6.73,0,0,1-1,1.34A1.79,1.79,0,0,1,89.94,92.23Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "_7",
  "data-name": 7
}, /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-2 animate-me",
  d: "M105.72,19.37a4.19,4.19,0,0,1,2.63.66c.84.4,1.68.77,2.53,1.15.61.28.67.56.19.95-1,.8-4.54,1-5.6.24a1.62,1.62,0,0,1-.8-1.53c0-.48-.09-.68-.61-.8a1.71,1.71,0,0,1-1.51-2.29,24.25,24.25,0,0,1,2.24-6c.15-.28.32-.63.72-.51s.38.48.42.8A28.09,28.09,0,0,1,105.72,19.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-3 animate-me",
  d: "M97.81,19.2a9.59,9.59,0,0,1,3.06.63,2.1,2.1,0,0,1,1.34,1.31,1.32,1.32,0,0,1-.29,1.45,1.26,1.26,0,0,1-1.34.3,3.29,3.29,0,0,1-.87-.41c-1.1-.73-2.19-1.48-3.29-2.22-.2-.14-.44-.27-.36-.56a.61.61,0,0,1,.56-.4C97,19.25,97.41,19.23,97.81,19.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-4 animate-me",
  d: "M100.14,28.68a12.47,12.47,0,0,1,.54-2.93,2.54,2.54,0,0,1,.8-1.18,1.5,1.5,0,0,1,1.9-.05,1.52,1.52,0,0,1,.42,1.85,1.61,1.61,0,0,1-.25.42,15.82,15.82,0,0,1-2.39,2.38.73.73,0,0,1-.78.18C100.07,29.18,100.13,28.87,100.14,28.68Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "_6",
  "data-name": 6,
  className: "sparkle1-item-5 animate-me",
  d: "M92.27,7a111.43,111.43,0,0,1-1.86,19c-1.63,9.3-3.12,18.63-5.08,27.87C84.14,59.53,83,65.15,81.49,70.68a28.6,28.6,0,0,1-1.44,4.24,3.38,3.38,0,0,1-.88,1.29,1.4,1.4,0,0,1-2.35-.77A3.76,3.76,0,0,1,77,73.53c2.22-7.94,3.75-16,5.39-24.11s3.05-16.35,4.28-24.57A113.69,113.69,0,0,1,91,7,1.55,1.55,0,0,1,91,6.75c.22-.44.19-1.25.87-1.09S92.26,6.54,92.27,7Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_5",
  "data-name": 5,
  className: "sparkle1-item-6 animate-me",
  d: "M70.51,2C70.19,6,70.38,10,69.83,14a8.37,8.37,0,0,1-.36,1.65,1.56,1.56,0,0,1-1.55,1.13,1.59,1.59,0,0,1-1.37-1.2,4.13,4.13,0,0,1-.13-2A108.62,108.62,0,0,1,69.35,1.34c.15-.5.24-1.44.78-1.33s.28,1,.38,1.58A2.16,2.16,0,0,1,70.51,2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_4",
  "data-name": 4,
  className: "sparkle1-item-7 animate-me",
  d: "M74.54,46a26.74,26.74,0,0,1-5.65-1c-2.22-.58-2.16-1-4,1.27-1.42,1.8-2.92,3.55-4.39,5.31a5,5,0,0,1-.76.77,2.15,2.15,0,0,1-3.53-1,12.3,12.3,0,0,1-.53-3.46,15.6,15.6,0,0,1,0-2,1.43,1.43,0,0,0-1.12-1.61A36.52,36.52,0,0,1,48,41a9.51,9.51,0,0,1-1.38-1,2,2,0,0,1,.26-3.39,2.87,2.87,0,0,1,1.24-.46,12.61,12.61,0,0,1,3.83-.26c.91.16,1.06,0,1.14-.92.3-3.42.55-6.83.71-10.26.09-2,1.69-2.9,3.46-1.86a8.74,8.74,0,0,1,1.5,1.21c1.33,1.24,2.67,2.46,4,3.72a1.75,1.75,0,0,0,2.18.39c2.05-.95,4.13-1.83,6.19-2.75,1-.43,1.89-.83,2.85-.1a2.53,2.53,0,0,1,.7,2.77c-.37,2.07-.8,4.12-1.31,6.15A3.19,3.19,0,0,0,73.74,37c1,1.56,2,3.16,3,4.68a7.27,7.27,0,0,1,.69,1.13A2.14,2.14,0,0,1,75.79,46,11.21,11.21,0,0,1,74.54,46Zm-4.1-16.18c-.6.25-.93.39-1.25.54-1.44.63-2.89,1.24-4.32,1.9a2.78,2.78,0,0,1-3.25-.45c-.77-.66-1.51-1.34-2.29-2a12.36,12.36,0,0,0-2-1.59,2.56,2.56,0,0,0-.14.44c-.23,2.44-.52,4.89-.88,7.32-.1.63-.28,1-.87,1.09a4.69,4.69,0,0,0-.81.24,12.44,12.44,0,0,0-2.81,1.27,1.67,1.67,0,0,0,.82.64A40.33,40.33,0,0,0,57,41.12a3.36,3.36,0,0,1,2.4,3.52c0,.58-.27,1.51.23,1.68s.91-.73,1.3-1.18a38.73,38.73,0,0,1,2.84-3.29,4,4,0,0,1,4-1.08c1.12.31,2.25.6,3.39.89.26.07.54.21.78-.08.06-.36-.21-.59-.37-.86-.42-.69-.82-1.39-1.29-2a5.53,5.53,0,0,1-.76-5.06C69.9,32.47,70.11,31.28,70.44,29.86Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_3",
  "data-name": 3,
  className: "sparkle1-item-8 animate-me",
  d: "M59.75,78.85a1.89,1.89,0,0,1-1.35,2,1.62,1.62,0,0,1-1.94-1.24c-1.82-4.8-4.13-9.38-6.31-14-2.84-6-5.81-12-8.86-17.91-3.2-6.21-6.47-12.38-9.73-18.55A30.49,30.49,0,0,1,29,22.65c-.18-.66-.45-1.3-.66-1.95a7.09,7.09,0,0,1-.26-.93.59.59,0,0,1,1-.61,1.87,1.87,0,0,1,.34.35c1.65,2.29,3.67,4.31,5,6.83s2.71,5,4,7.59c3.86,7.41,7.76,14.8,11.4,22.32,3,6.32,6.17,12.62,8.85,19.11A13.69,13.69,0,0,1,59.75,78.85Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_2",
  "data-name": 2,
  className: "sparkle1-item-9 animate-me",
  d: "M43.15,80.65a1.68,1.68,0,0,1-.87,1.52A1.62,1.62,0,0,1,40.46,82a4.65,4.65,0,0,1-.88-1Q29.41,66.22,19.23,51.47c-2.74-3.95-5.59-7.82-8.4-11.72a30.52,30.52,0,0,1-3.47-6.09c-.45-1.07-1-2.11-1.5-3.17a2,2,0,0,1-.27-1.28A.41.41,0,0,1,6.3,29a6.27,6.27,0,0,1,.87.84,48.46,48.46,0,0,0,3.44,3.58,48.25,48.25,0,0,1,4.8,6.23C22.8,49.65,29.8,60,36.8,70.31c1.83,2.7,3.79,5.33,5.47,8.14A4.64,4.64,0,0,1,43.15,80.65Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "_1",
  "data-name": 1
}, /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-10 animate-me",
  d: "M10.47,64.63A1.78,1.78,0,0,1,9.25,66.5a1.63,1.63,0,0,1-2-.91,6.87,6.87,0,0,1,.13-5.39c.2-.46.59-.48.78,0a30.08,30.08,0,0,0,2,3.43A2.11,2.11,0,0,1,10.47,64.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-11 animate-me",
  d: "M5,69.57a16.39,16.39,0,0,0-3.68.5c-.42.09-1,.39-1.23,0S.36,69.27.65,69a8.83,8.83,0,0,1,4.14-2.33A2.19,2.19,0,0,1,7,67.35a1.27,1.27,0,0,1-.79,2.22C5.79,69.61,5.39,69.57,5,69.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-12 animate-me",
  d: "M12.47,67.39a1.74,1.74,0,0,1-1.78-1.2,1.55,1.55,0,0,1,.79-1.84,26.38,26.38,0,0,1,4.58-1.5c.53-.12.78.17.55.57a10.09,10.09,0,0,1-3.47,3.78A2.81,2.81,0,0,1,12.47,67.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sparkle1-item-13 animate-me",
  d: "M11.39,70A24.52,24.52,0,0,0,11,73.25c0,.48-.35.62-.76.46a1.52,1.52,0,0,1-.58-.42A6.53,6.53,0,0,1,8.2,70.56a2.59,2.59,0,0,1,0-1A1.68,1.68,0,0,1,9.94,68,1.69,1.69,0,0,1,11.39,70Z"
})));

var SvgSparkle1 = function SvgSparkle1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 128.7 92.23",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSparkle1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sparkle-1.024f7d51.svg";
export { ForwardRef as ReactComponent };